import React from 'react';

/*
 * Displays the survey type based on the Done survey that was started
 */
export default settings => {
    return ({ value, row }) => {
        const youthAssignment = ['assignment41', 'assignment42'];
        const teenAssignment = ['assignment39', 'assignment40'];

        let type = '';

        if (row['fields.screened'] === true) {
            type = '< 9';
        } else {
            let assignmentHandle = row['assignmentProgress.assignmentHandle'];
            if (youthAssignment.includes(assignmentHandle)) {
                type = 'youth';
            } else if (teenAssignment.includes(assignmentHandle)) {
                type = 'teen';
            } else {
                type = '';
            }
        }

        return <div>{type}</div>;
    };
};
